export isActualNaN = (value) ->
  value != value
